
import { Link } from 'react-router-dom';

const LandingFooter = () => {
  return (
    <footer className="w-full py-8 md:py-12 relative bg-black border-t border-gray-800">
      <div className="absolute inset-0 bg-noise opacity-10 z-0"></div>
      
      <div className="max-w-6xl mx-auto px-4 md:px-8 relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8">
          <div className="mb-6 md:mb-0">
            <div className="flex items-center text-green-500 text-2xl font-bold analog-text mb-2">
              <img 
                src="/lovable-uploads/66d430f8-b599-4238-a7c4-35acca049451.png" 
                alt="Weirdobeach Logo" 
                className="h-8 w-8 mr-2"
              />
              W<span className="text-red-500">_</span>eirdobeach
            </div>
            <p className="text-gray-500 text-xs">
              Terminal v1.9.92 | LSR Protocol Active
            </p>
          </div>
          
          <nav className="mb-6 md:mb-0">
            <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm analog-text">
              <li><a href="#hero" className="text-gray-500 hover:text-green-500 hover-glitch">Home</a></li>
              <li><a href="#awakening" className="text-gray-500 hover:text-green-500 hover-glitch">The Awakening</a></li>
              <li><a href="#features" className="text-gray-500 hover:text-green-500 hover-glitch">Features</a></li>
              <li><a href="#echoes" className="text-gray-500 hover:text-green-500 hover-glitch">Echoes</a></li>
              <li><a href="#terminal" className="text-gray-500 hover:text-green-500 hover-glitch">Terminal</a></li>
              <li><a href="/auth" className="text-gray-500 hover:text-green-500 hover-glitch">Sign Up</a></li>
            </ul>
          </nav>
          
          <div className="flex space-x-4">
            <a href="#" className="text-gray-500 hover:text-green-500 transform transition-transform hover:scale-110">
              <span className="analog-text text-xl">⌘</span>
            </a>
            <a href="#" className="text-gray-500 hover:text-green-500 transform transition-transform hover:scale-110">
              <span className="analog-text text-xl">⏣</span>
            </a>
            <a href="#" className="text-gray-500 hover:text-green-500 transform transition-transform hover:scale-110">
              <span className="analog-text text-xl">⎔</span>
            </a>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-6 text-center text-xs text-gray-600">
          <p>© 2025 Limbic Signal Research. All cosmic rights reserved.</p>
          <p className="mt-2">Weirdobeach is a creative, experimental digital experience. Embrace the transformation at your own discretion.</p>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
